import * as e from "react";
const v = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.657 3a2.196 2.196 0 00-2.195 2.196v3.147c0 1.212.983 2.196 2.195 2.196h3.147A2.196 2.196 0 0012 8.343V5.196A2.196 2.196 0 009.804 3H6.657zm-.195 2.196c0-.108.087-.196.195-.196h3.147c.108 0 .196.088.196.196v3.147a.196.196 0 01-.196.195H6.657a.196.196 0 01-.195-.195V5.196zM13.461 10.504c0-1.213.984-2.196 2.196-2.196h4.378c1.213 0 2.196.983 2.196 2.196v4.377a2.196 2.196 0 01-2.196 2.196h-4.378a2.196 2.196 0 01-2.196-2.196v-4.377zm2.196-.196a.196.196 0 00-.196.196v4.377c0 .108.088.196.196.196h4.378a.196.196 0 00.196-.196v-4.377a.196.196 0 00-.196-.196h-4.378zM2 14.196C2 12.983 2.983 12 4.196 12h5.608c1.213 0 2.196.983 2.196 2.196v5.608A2.196 2.196 0 019.804 22H4.196A2.196 2.196 0 012 19.804v-5.608zM4.196 14a.196.196 0 00-.196.196v5.608c0 .108.088.196.196.196h5.608a.196.196 0 00.196-.196v-5.608A.196.196 0 009.804 14H4.196z",
      fill: "#292933"
    }
  )
);
export {
  v as default
};
